import { render } from "./totalProfitsPackage.vue?vue&type=template&id=0c5cdf1a&scoped=true"
import script from "./totalProfitsPackage.vue?vue&type=script&lang=js"
export * from "./totalProfitsPackage.vue?vue&type=script&lang=js"

import "./totalProfitsPackage.vue?vue&type=style&index=0&id=0c5cdf1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5cdf1a"]])

export default __exports__